import React from 'react';
import { Card, CardTitle } from 'react-bootstrap';
import ProfitFunction from './ProfitFunction';
import { useParams, Link } from 'react-router-dom';



const CustomerMargin = (props) => {

  const { customerId } = useParams();
  return (
    <Card className="CustomerInsights" header="Customer Insights">
      <CardTitle>Customer Insights</CardTitle>
      <div><ProfitFunction contactName={customerId} months='3' /></div>
      <div><Link to={'/customervolume/' + customerId}>Customer Units Sold </Link></div>
      <div><Link to={'/customer/' + customerId}>Customer Sales</Link></div>
      <div><Link to={'/productbreakdown/' + customerId}>See YoY Product Breakdown</Link></div>
    </Card>
  )
}
export default CustomerMargin;
